import React from 'react';
import CreditSettlementReportsHeader from './CreditSettlementReportsHeader';
import CreditSettlementReportsContent from './CreditSettlementReportsContent';

const CreditSettlementReports = () => {
    return (
        <>
            <CreditSettlementReportsHeader />
            <CreditSettlementReportsContent />
        </>
    );
};

export default CreditSettlementReports;
